;(function($){

  $(window).ready(init);

  function init() {
    var HIDDENSLUG = $('.ContentArchiveFav-hiddenSlug').text();
    var ARCHIVELIST = $('.ContentArchiveFav-place');

    $(ARCHIVELIST).each(function(){
      if ($(this).hasClass(HIDDENSLUG)){
        $(this).addClass('current');
      }
    })
  }

})(jQuery);
